import { useId } from 'react';

/**
 * **Une case à cocher dans une liste de choix.**
 *
 * Elle diffère d'`Interrupteur`, et l'écart n'est pas cosmétique : **un interrupteur prend
 * effet à l'instant**, une case attend un geste de validation. Les confondre ferait
 * partager un dossier à chaque clic dans la liste des destinataires, au lieu d'attendre le
 * bouton « Partager ».
 *
 * L'élément natif est encapsulé, jamais remplacé : il arrive au clavier, s'annonce et se
 * coche à la barre d'espace sans qu'on l'écrive.
 */
type Props = {
  readonly libelle: string;
  readonly coche: boolean;
  readonly desactivee?: boolean;
  readonly onChanger: (coche: boolean) => void;
};

export function CaseACocher({
  libelle,
  coche,
  desactivee = false,
  onChanger,
}: Props) {
  const id = useId();
  return (
    <span className="flex items-center gap-2">
      <input
        id={id}
        type="checkbox"
        checked={coche}
        disabled={desactivee}
        onChange={(evenement) => onChanger(evenement.target.checked)}
        className={[
          'size-5 shrink-0 cursor-pointer appearance-none rounded-1',
          'border border-bord-champ bg-fond-surface',
          'transition-colors duration-1',
          'checked:border-action checked:bg-action',
          'disabled:cursor-not-allowed disabled:opacity-50',
          'focus-visible:outline focus-visible:outline-2',
          'focus-visible:outline-offset-2 focus-visible:outline-focus',
        ].join(' ')}
      />
      <label htmlFor={id} className="cursor-pointer text-14 text-texte">
        {libelle}
      </label>
    </span>
  );
}
